import { render } from "./Button.md?vue&type=template&id=224fb572"
const script = {}
script.render = render

export default script